<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import myMixin from "./mixins.js";

export default {
  name: "app",
  data: function() {
    return {
      transitionName: "slide-right",
    };
  },
  mixins: [myMixin],
  watch: {
    $route(to) {
      this.fetchData();
      const toPath = to.path;
      this.transitionName =
        toPath == "/resources/map" ? "slide-left" : "slide-right";
    },
  },
};
</script>

<style lang="scss">
body,
html {
  background-color: #f8f1e6;
  height: 100%;
}
h2 {
  font-size: 24px;
  color: #325672;
  margin: 10px 0px;
}
h3 {
  font-size: 18px;
  margin: 7px 0px;
}
p {
  font-size: 16px;
  line-height: 1.5em;
}

.sources-page,
.about-page {
  text-align: left;
  main {
    padding: 10px;
    background-color: white;
  }
}

// .slide-left-enter-active,
// .slide-left-leave-active,
// .slide-right-enter-active,
// .slide-right-leave-active {
//   transition: all .75s ease-out;
//   transition-duration: .75s !important;
//   transition-property: transform !important;
//   transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1) !important;
// }

// .slide-left-enter,
// .slide-right-leave-active {
//   transform: translate(100vw, 0) !important;
// }

// .slide-left-leave-active,
// .slide-right-enter {
//   transform: translate(-100vw, 0) !important;
// }

// .slide-left-enter,
// .slide-right-leave-active {
//   opacity: 0;
//   transform: translate(2em, 0);
// }

// .slide-left-leave-active,
// .slide-right-enter {
//   opacity: 0;
//   transform: translate(-2em, 0);
// }

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  position: absolute;
  width: 100vw;
  max-width: 100vw !important;
  // overflow:hidden !important;
  transition: all 0.65s ease;
}

.slide-right-enter-to {
  transform: translate(0, 0) !important;
}

.slide-right-enter {
  transform: translate(100%, 0) !important;
}

.slide-right-leave-to {
  transform: translate(-100%, 0) !important;
}

.slide-right-leave {
  transform: translate(0, 0) !important;
}

////left
.slide-left-enter-to {
  transform: translate(0, 0) !important;
  // right: 0;
}

.slide-left-enter {
  transform: translate(-100%, 0) !important;
  // right: -100%;
}

.slide-left-leave-to {
  transform: translate(100%, 0) !important;
  // left: -100%;
}

.slide-left-leave {
  transform: translate(0, 0) !important;
  // left: 0;
}

.about-this-map-container {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ul {
    display: flex;
    flex-direction: row;
    list-style-type: none;
    padding: 0px;
    li {
      margin: 0px 10px;
      font-weight: bold;
    }
  }
}

.fixed-credits-container,
.relative-credits-container {
  a {
    color: #999999 !important;
  }
}

.fixed-credits-container {
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.relative-credits-container {
}

.fixed-credits-container,
.relative-credits-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 5px;
  z-index: 1000;
  height: 30px;
  width: 100%;
  justify-content: flex-end;
}

.about-this-map-header {
  button {
    background: linear-gradient(orange, #d19c16);
    border-color: orange;
    color: #fff;
    font-weight: bold;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  background-color: #f8f1e6;
  .map-page {
    .studies-map {
      height: 100vh !important;
      div:not(.table-buttons):not(.relative-credits-container):not(.fixed-credits-container) {
        height: calc(100vh - 60px) !important;
        .hc {
          height: calc(100vh - 60px) !important;
          .highcharts-container {
            height: calc(100vh - 60px) !important;
            .highcharts-root {
              height: calc(100vh - 60px) !important;
            }
          }
        }
      }
    }
  }
  .md-card {
    box-shadow: none !important;
  }
}

.subpages-header {
  background-color: #325672;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  padding: 5px;
  position: sticky;
  left: 0px;
  h2 {
    color: #fff;
  }
  button {
    background: linear-gradient(orange, #d19c16);
    border-color: orange;
    color: #fff;
    font-weight: bold;
  }
}

button {
  border-radius: 4px;
  background-color: #2c3e50;
  font-size: 14px;
  color: white;
  background-color: #2c3e50;
  padding: 5px;
  border: 0.5px solid #2c3e50;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: mix(#2c3e50, black, 50%);
  }
}
</style>
